/*
  ComposeRequest.js - Handles composing of request for SMS Send
*/

// OUR MODULES
import RequestRabbit from './RequestRabbit';
import config from '../Config';

const useUserRequest = () => {
  // Get user access level
  const getLevel = (a) => {
    switch (a) {
      case 1:
        return 'H';
      case 2:
        return 'R';
      case 3:
        return 'A';
      default:
        return 'S';
    }
  };

  const deleteCentre = async (id, errorHandler) => {
    const url = `${config.baseServerURL}/costcentre/delete`;
    const header = {
      'Content-Type': 'application/json',
    };
    let body = {
      centreId: id,
    };
    body = JSON.stringify(body);
    let options = {
      method: 'POST',
      headers: header,
      body: body,
    };
    try {
      console.log('Received options:', options);
      // Request data
      let response = await RequestRabbit.request(url, options, errorHandler);
      console.log('user reports rsp:', response);
      let responseJSON = await response?.json();
      return responseJSON;
    } catch (e) {
      //Error catching
      errorHandler(e);
    }
  };

  const updateCentre = async (id, name, contact, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/costcentre/update`;
      const header = { 'Content-Type': 'application/json' };
      let body = JSON.stringify({
        centreId: id,
        centreName: name,
        contact_id: contact,
      });
      let options = {
        method: 'POST',
        headers: header,
        body: body,
      };
      // Request
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      //Error catching
      errorHandler(e);
    }
  };

  /*
    Gets data about the selected User
  */
  const selectedUser = async (user, type, page, errorHandler) => {
    let level = type;
    if (page === 'report') {
      level = this.getLevel(type);
    }
    console.log(user, level);
    const url = `${config.baseServerURL}/admin/users/${level}/${user}`;
    const header = {
      'Content-Type': 'application/json',
    };
    let options = {
      method: 'GET',
      headers: header,
    };

    try {
      console.log('Received options:', options);
      // Request data
      let response = await RequestRabbit.request(url, options, errorHandler);
      console.log('user reports rsp:', response);
      let responseJSON = await response?.json();
      return responseJSON;
    } catch (e) {
      //Error catching
      errorHandler(e);
    }
  };

  /*
    Find Customer (Administrators only)

    // 0 - customer_id, 1 - customer_name, 2 - customer_domain
    // 3 - customer_auth, 4 - customer_ip_address, , 5 - error handler
  */
  const searchForAdminCustomer = async (
    customerId,
    customerName,
    customerDomain,
    customerAuth,
    customerIpAddress,
    errorHandler
  ) => {
    //param[5] is the error handler function
    try {
      let url = `${config.baseServerURL}/admin/search/customer`;

      let body = {};
      if (customerId) body.accountId = customerId;
      if (customerName) body.name = customerName;
      if (customerDomain) body.domain = customerDomain;
      if (customerAuth) body.authorisationCode = customerAuth;
      if (customerIpAddress) body.ipAddress = customerIpAddress;

      const header = {
        'Content-Type': 'application/json',
      };
      let options = {
        method: 'POST',
        headers: header,
        body: JSON.stringify(body),
      };

      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      console.log('Admin Search JSON:', responseJSON);
      console.log('response?.status:', response?.status);

      if (response?.status > 399 && response?.status < 600) {
        return [];
      }
      return responseJSON;
    } catch (e) {
      console.log('Got err:', e.message);
      errorHandler(e.message);
      return [];
    }
  };

  /*
    Find User (Administrators only)

    // 0 - user_id, 1 - user_name, 2 - user_email, 3 - user_phone, 3 - error handler
  */
  const searchForAdminUser = async (
    userId,
    userName,
    userEmail,
    userPhone,
    errorHandler
  ) => {
    try {
      let url = `${config.baseServerURL}/admin/search/user`;

      let body = {};
      if (userId) body.userId = userId;
      if (userName) body.name = userName;
      if (userEmail) body.emailAddress = userEmail;
      if (userPhone) body.mobileNumber = userPhone;

      const header = {
        'Content-Type': 'application/json',
      };
      let options = {
        method: 'POST',
        headers: header,
        body: JSON.stringify(body),
      };

      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      if (response?.status > 399 && response?.status < 600) {
        return [];
      }
      return responseJSON;
    } catch (e) {
      errorHandler(e);
      return [];
    }
  };

  /*
    Find User Admin (Administrators only)

    // 0 - admin_name, 1 - admin_email, 2 -error handler
  */
  const searchForAdminUserAdmin = async (
    adminName,
    adminEmail,
    errorHandler
  ) => {
    //params 2 is the error handler function
    try {
      let url = `${config.baseServerURL}/admin/search/admin`;

      let body = {};
      if (adminName) body.name = adminName;
      if (adminEmail) body.emailAddress = adminEmail;

      const header = {
        'Content-Type': 'application/json',
      };
      let options = {
        method: 'POST',
        headers: header,
        body: JSON.stringify(body),
      };
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
    }
  };

  /*
    Find Errors by Destination Email (Administrators only)

    // 0 - error_email, 1 -error handler
  */
  const searchForAdminErrorEmail = async (errorEmail, errorHandler) => {
    //param 1 is the error function
    try {
      let url = `${config.baseServerURL}/admin/search/erroremail`;
      let body = {};
      if (errorEmail) body.emailAddress = errorEmail;

      const header = {
        'Content-Type': 'application/json',
      };
      let options = {
        method: 'POST',
        headers: header,
        body: JSON.stringify(body),
      };

      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
    }
  };

  /*
    Search by Destination Mobile Number (Administrators only)

    // 0 - destination_number, 1 - error handler
  */
  const searchForAdminDestTn = async (destinationNumber, errorHandler) => {
    // params[1] is the errorhandler function
    try {
      let url = `${config.baseServerURL}/admin/search/message`;

      let body = {};
      if (destinationNumber) body.destinationNumber = destinationNumber;

      const header = {
        'Content-Type': 'application/json',
      };
      let options = {
        method: 'POST',
        headers: header,
        body: JSON.stringify(body),
      };

      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
    }
  };

  /*
    Gets all applicable Cost Centres for a given Customer Id
  */
  const getCostCentres = async (customerId, errorHandler) => {
    const url = `${config.baseServerURL}/customer/${customerId}/centre`;
    const header = {
      'Content-Type': 'application/json',
    };
    let options = {
      method: 'GET',
      headers: header,
    };
    // Request
    let response = await RequestRabbit.request(url, options, errorHandler);
    let responseJSON = await response?.json();

    return responseJSON;
  };

  /*
    Fetch all Customer Users for the calling Customer
  */
  const getUsers = async (
    pageNumber,
    pageLength,
    name,
    email,
    number,
    errorHandler
  ) => {
    try {
      const params = {
        pageNumber,
        pageLength,
      };

      if (name) params.name = name;
      if (email) params.email = email;
      if (number) params.number = number;

      const urlSearchParams = new URLSearchParams(params);

      const url = `${
        config.baseServerURL
      }/users/?${urlSearchParams.toString()}`;
      const headers = {
        'Content-Type': 'application/json',
      };
      let options = {
        method: 'GET',
        headers,
      };

      // Request
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      //Error catching
      errorHandler(e.message);
    }
  };

  const getUserById = async (id, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/users/${id}`;
      const headers = {
        'Content-Type': 'application/json',
      };
      let options = {
        method: 'GET',
        headers,
      };

      // Request
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      //Error catching
      errorHandler(e.message);
    }
  };

  /*
    Get user info
  */
  const getUser = async (data, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/users/user`;
      const headers = {
        'Content-Type': 'application/json',
      };
      const options = {
        method: 'GET',
        headers: headers,
      };

      // Request
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
    }
  };

  /*
   Get Dedicated Numbers
   */
  const getDedicatedNumbers = async (customerUserId, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/users/number/${customerUserId}`;
      const headers = {
        'Content-Type': 'application/json',
      };
      const options = {
        method: 'GET',
        headers: headers,
      };

      console.log('getDedicatedNumbers called');
      console.log(customerUserId);

      // Request
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
    }
  };

  /*
    Fetches campaign data for the customer.
  */
  const getCustomerCampaignData = async (customerId, errorHandler) => {
    try {
      const url =
        `${config.baseServerURL}/admin/customer/campaigns/` + customerId;
      const options = {
        method: 'GET',
      };

      // Make Request
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      return errorHandler(e);
    }
  };

  /*
    Creates a new Customer User for the Customer
  */
  const createUser = async (data, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/users`;
      const header = {
        'Content-Type': 'application/json',
      };
      const body = JSON.stringify(data);
      const options = {
        method: 'POST',
        headers: header,
        body: body,
      };
      // Request
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
    }
  };

  /*
    Creates a request to update a specific User.

    Inputs:
      - data: A JSON object containing updated details of the Customer User
      - errorHandler: A function to be called if an error occurs
  */
  const updateUser = async (customerUserId, data, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/users/${customerUserId}`;
      const headers = {
        'Content-Type': 'application/json',
      };
      const options = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data),
      };

      // Request
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
    }
  };

  /*
    Cancels the specified Customer User
  */
  const cancelUser = async (userId, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/users/${userId}`;
      const options = {
        method: 'DELETE',
      };

      // Request
      await RequestRabbit.request(url, options, errorHandler);
    } catch (e) {
      errorHandler(e.message);
    }
  };

  /*
    Fetches all Cost Centres for a given Customer's id
  */
  const getCentres = async (errorHandler) => {
    try {
      const url = `${config.baseServerURL}/centre/`;
      let options = { method: 'GET' };

      // Request
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
    }
  };

  /*
    Calls TWILIO api to request 20 possible numbers for a given Country Code and Prefix
  */
  const searchAvailableNumbers = async (data, errorHandler) => {
    try {
      let url = `${config.baseServerURL}/users/number/search?countryCode=${data.country}`;

      if (data.prefix) url += `&areaCode=${data.prefix}`;
      if (data.gateway) url += `&gateway=${data.gateway}`;
      if (data.numberContains) url += `&numberContains=${data.numberContains}`;

      const headers = {
        'Content-Type': 'application/json',
      };
      const options = {
        method: 'GET',
        headers: headers,
      };

      // Request
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
    }
  };

  const provisionNumbers = async (data, errorHandler) => {
    try {
      //let {numbers, templateDeviceId, customerUserId} = data;
      console.log('provisionTwilioNumbers called');
      let url = `${config.baseServerURL}/users/number/provision`;
      const headers = {
        'Content-Type': 'application/json',
      };
      const options = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data),
      };

      console.log('options:', options);

      // Request
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      console.log('responseJSON:', responseJSON);
      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
    }
  };

  const releaseTwilioNumbers = async (data, errorHandler) => {
    try {
      //let {numbers, templateDeviceId, customerUserId} = data;
      console.log('releaseTwilioNumbers called');
      let url = `${config.baseServerURL}/users/number/release`;
      const headers = {
        'Content-Type': 'application/json',
      };
      const options = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data),
      };

      console.log('JSON.stringify(data):', JSON.stringify(data));
      console.log('options:', options);

      // Request
      let response = await RequestRabbit.request(url, options, errorHandler);
      console.log('response', response);
      return response;
    } catch (e) {
      errorHandler(e.message);
    }
  };

  const changeCampaignForNumbers = async (data, customerId, errorHandler) => {
    try {
      console.log('changeCampaignForNumbers called');
      let url = `${config.baseServerURL}/users/number/change`;
      const headers = {
        'Content-Type': 'application/json',
      };
      const options = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ numbers: data, customerId: customerId }),
      };

      // Request
      let response = await RequestRabbit.request(url, options, errorHandler);
      console.log('response', response);
      return response;
    } catch (e) {
      errorHandler(e.message);
    }
  };
  /*
    Transfer Dedicated Number to another User
  */
  const transferDedicatedNumber = async (
    deviceId,
    dedicatedNumber,
    fromUserId,
    errorHandler
  ) => {
    try {
      console.log('transferDedicatedNumber called');
      let url = `${config.baseServerURL}/users/number/transfer`;
      const headers = {
        'Content-Type': 'application/json',
      };
      const options = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          deviceId: deviceId,
          dedicatedNumber: dedicatedNumber,
          fromUserId: fromUserId,
        }),
      };

      // Request
      let response = await RequestRabbit.request(url, options, errorHandler);
      console.log('response', response);
      return response;
    } catch (e) {
      errorHandler(e.message);
    }
  };
  /*
    Find User Search

    // params: 0 - name, 1 - email, 2 - mob, 3-error handler
  */
  const searchForUser = async (searchBody, errorHandler) => {
    try {
      let url = `${config.baseServerURL}/users/search`;

      const header = {
        'Content-Type': 'application/json',
      };
      let options = {
        method: 'POST',
        headers: header,
        body: JSON.stringify(searchBody),
      };

      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
    }
  };

  return {
    getCentres,
    getCostCentres,
    getCustomerCampaignData,
    getDedicatedNumbers,
    getLevel,
    getUser,
    getUserById,
    getUsers,
    cancelUser,
    updateUser,
    createUser,
    updateCentre,
    selectedUser,
    deleteCentre,
    changeCampaignForNumbers,
    releaseTwilioNumbers,
    provisionNumbers,
    searchAvailableNumbers,
    searchForAdminCustomer,
    searchForAdminDestTn,
    searchForAdminErrorEmail,
    searchForAdminUser,
    searchForAdminUserAdmin,
    transferDedicatedNumber,
    searchForUser,
  };
};

export default useUserRequest;
